// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"dff806f6","453":"9ac8bd8c","524":"93abda9a"}[chunkId] + ".chunk.js";
};